import { PropsWithChildren } from "react";
import { Container, Content, Label } from "./styles";

type Props = PropsWithChildren<{
  label: string;
  hide: boolean;
}>;

const Group: React.FC<Props> = (props) => {
  const { label, hide, children } = props;

  return (
    <Container>
      <Label $hide={hide}>{label}</Label>
      <Content $hide={hide}>{children}</Content>
    </Container>
  );
};

export default Group;
